import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Text } from "components/shared/text"

export type SingleStatProps = {
  label: string
  value: string
}

export function SingleStat({ label, value }: SingleStatProps) {
  const { isMobile } = useTailwindBreakpoints()
  return (
    <Box
      row
      className="w-full justify-between items-center bg-[#4F4ACC80] rounded p-2 mb-3 lg:rounded-2xl lg:px-3 lg:py-4 lg:mb-8"
    >
      <Text weight="bold" className="uppercase text-[#9188E2]" size={isMobile ? "tiny" : "lg"}>
        {label}
      </Text>
      <Text weight="bold" size={isMobile ? "sm" : "lg"}>
        {value}
      </Text>
    </Box>
  )
}
